import React, { PureComponent, Fragment } from "react";
import PropTypes from "prop-types";
import { OutboundLink } from "gatsby-plugin-google-gtag";

export const Facebook = ({ children, ...others }) => (
  <OutboundLink {...others} href="https://facebook.com/screenpresso">
    <span className="icon">
      <i className="fab fa-facebook" />{" "}
    </span>
    {children || "Facebook"}
  </OutboundLink>
);

Facebook.propTypes = {
  children: PropTypes.object,
};


export class FacebookLikeButton extends PureComponent {
  constructor(props) {
    super(props);
    this.buttonRef = React.createRef();
  }

  /**
   * Forces the reload of the twitter javascript defined in html.js
   */
  componentDidMount() {
    // eslint-disable-next-line no-undef
    if (typeof FB !== "undefined" && FB.XFBML) {
      const node = this.buttonRef.current;

      try {
        // eslint-disable-next-line no-undef
        FB.XFBML.parse(node.parentNode);
      } catch (error) {
        console.error("Error during FB.XFBML.parse", error);
      }
    }
  }

  render() {
    return (
      <div
        ref={this.buttonRef}
        className="fb-like"
        data-href="https://www.facebook.com/screenpresso"
        data-layout="standard"
        data-action="like"
        data-size="small"
        data-show-faces="true"
        data-share="true"
        style={{marginBottom: "20px"}}
      />
    );
  }
}
